import React from "react";
import { useMsal } from "@azure/msal-react";
import { Typography, Box, useTheme, Button } from "@mui/material";

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
export const SignOutButton = () => {
    const { instance } = useMsal();
    
    const handleLogout = (logoutType) => {
        if (logoutType === "redirect") {
           instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    return (
        <Button variant="secondary" sx={{backgroundColor:"#af3f3b", marginLeft:1, marginTop:2, width:200}} className="ml-auto" onClick={() => handleLogout("redirect")}>Sign out</Button>
    );
}